module.exports = __webpack_public_path__ + "static/media/print-example-0-3-17-200.4808c80f.png";